var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:('Not Found Page - BS Music'),expression:"'Not Found Page - BS Music'"}],attrs:{"id":"Err"}},[_c('p',[_vm._v("Not Found Page")])])}
var staticRenderFns = []

export { render, staticRenderFns }